const advertisingAdd = {
    path: '/ad/advertising/add',
    component: resolve => require(['@/pages/admin/ad/advertising/add.vue'], resolve)
}

export default advertisingAdd